export default __webpack_public_path__ + "static/media/solution_91.52e62908.png";